const timesheetStatusColors = {
  normal: { bg: '#dcfce7', text: '#16a34a' },
  absent: { bg: '#fee2e2', text: '#dc2626' },
  leave: { bg: '#dbeafe', text: '#2563eb' },
  // AKM POC §5.1 — kısmi izin: izin mavisinin açık tonu.
  partialLeave: { bg: '#e0f2fe', text: '#0369a1' },
  holiday: { bg: '#fef9c3', text: '#ca8a04' },
  halfDay: { bg: '#fce7f3', text: '#db2777' },
  missingExit: { bg: '#ffedd5', text: '#ea580c' },
  overtime: { bg: '#ede9fe', text: '#7c3aed' },
  dayOff: { bg: '#f3f4f6', text: '#6b7280' },
  workedOnDayOff: { bg: '#fef3c7', text: '#b45309' },
};

export default timesheetStatusColors;
